import { createFileRoute } from '@tanstack/react-router'
import { Receipt } from 'lucide-react'
import { InvoicesScreen } from '@/screens/billing/SCR-163-164-invoices'

export const Route = createFileRoute('/_app/billing/invoices')({
  staticData: { screen: { id: 'SCR-163', title: 'Invoices', group: 'Organisation', perm: ['billing.read', 'billing.manage'], order: 12, description: 'Every invoice and credit note, with GST, ready to download.', icon: Receipt } },
  component: InvoicesScreen,
})
